import { all, fork } from "redux-saga/effects";
import financeSaga from '../../views/finance-user/saga';

export default function* rootFinaceSaga() {
  // yield all([fork(fetchPaymentList())]);
  yield all([fork(financeSaga)]);
}